import { render, staticRenderFns } from "./AreaRow.vue?vue&type=template&id=4296fb74"
import script from "@/components/area-row/AreaRow.ts?vue&type=script&lang=ts&external"
export * from "@/components/area-row/AreaRow.ts?vue&type=script&lang=ts&external"
import style0 from "./area-row.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports